<template>
  <div class="row">
    <div class="col-lg-12 text-center">
      <h1>Settings</h1>
    </div>
    <div class="col-md-12">
      <card>
        <tabs type="primary" @click="getCurrent($event)">
          

          <tab-pane label="General">
            <div class="row">
              <div class="col-lg-4 ml-auto mr-auto">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Department</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      height="450"
                      :data="departmentData"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="130"
                        sortable
                        align="center"
                        label="Department"
                        property="department"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editdepartment = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                     
                  </div>
                  <!-- modal edit department -->
                  <modal
                    :show.sync="modals.editdepartment"
                    footer-classes="content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Department</h3>
                    <h5 class="text-left text-color">
                      Enter department details
                    </h5>
                    <div class="row">
                      <div class="col-md-12">
                        <!-- content -->
                        <form @submit.prevent>
                          <div>
                            <base-input
                              type="text"
                              label="Department Name"
                              placeholder="Department Name"
                              v-model="departmentName"
                            ></base-input>
                            <!-- <base-input
                              type="text"
                              label="Bin Capacity"
                              placeholder="Bin Capacity in L"
                              v-model="binType.binCapacity"
                            ></base-input>-->
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editDepartment()"
                              >Submit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editdepartment = false"
                              >Cancel</base-button
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </modal>
                  <!-- modal add department -->
                  <modal
                    :show.sync="modals.adddepartment"
                    footer-classes="content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Department</h3>
                    <h5 class="text-left text-color">
                      Enter department details
                    </h5>
                    <div class="row">
                      <div class="col-md-12">
                        <!-- content -->
                        <form @submit.prevent>
                          <div>
                            <base-input
                              type="text"
                              label="Department Name"
                              placeholder="Department Name"
                              v-model="departmentName"
                            ></base-input>
                            <!-- <base-input
                              type="text"
                              label="Bin Capacity"
                              placeholder="Bin Capacity in L"
                              v-model="binType.binCapacity"
                            ></base-input>-->
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addDepartment()"
                              >Submit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.adddepartment = false"
                              >Cancel</base-button
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </modal>
                  
                  <div class="col text-center">
                    <base-button
                      type="primary"
                      @click.native="modals.adddepartment = true"
                      >Add Department</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                </card>
              </div>
            </div>
          </tab-pane>
          <tab-pane label="Fleet">
            <div class="row">
              <div class="col-lg-2"></div>
              <div class="col-lg-4 d-flex">
                <!-- FLEET OVERVIEW -->
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Fleet Overview</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      height="450"
                      :data="fleetAttributesData"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="180"
                        sortable
                        align="center"
                        label="Fleet Attributes"
                        property="fleetAttributes"
                      ></el-table-column>
                      <el-table-column
                        min-width="90"
                        align="center"
                        label="Actions"
                      >
                        <div class="photo" slot-scope="{ row }">
                          <base-checkbox
                            class="mb-3"
                            v-model="row.check"
                          ></base-checkbox>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button type="primary" @click="updateFleetOverview()"
                      >Update Overview Display</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                </card>
              </div>

              <div class="col-lg-4 d-flex">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Fleet Status</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      height="450"
                      :data="fleetStatusData"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="140"
                        sortable
                        align="center"
                        label="Fleet Status"
                        property="fleetStatus"
                      ></el-table-column>
                      <el-table-column min-width="100" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editfleetstatus = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      type="primary"
                      @click.native="modals.addfleetstatus = true"
                      >Add Status</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <!-- modal edit fleet status -->
                  <modal
                    :show.sync="modals.editfleetstatus"
                    footer-classes="content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Fleet Status</h3>
                    <h5 class="text-left text-color">
                      Enter Fleet Status details
                    </h5>
                    <div class="row">
                      <div class="col-md-12">
                        <!-- content -->
                        <form @submit.prevent>
                          <div>
                            <base-input
                              type="text"
                              label="Status Name"
                              placeholder="Status Name"
                              v-model="fleetStatusName"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editFleetStatus()"
                              >Submit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editfleetstatus = false"
                              >Cancel</base-button
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </modal>
                  <!-- modal add fleet status -->
                  <modal
                    :show.sync="modals.addfleetstatus"
                    footer-classes="content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Fleet Status</h3>
                    <h5 class="text-left text-color">
                      Enter fleet status details
                    </h5>
                    <div class="row">
                      <div class="col-md-12">
                        <!-- content -->
                        <form @submit.prevent>
                          <div>
                            <base-input
                              type="text"
                              label="Status Name"
                              placeholder="Status Name"
                              v-model="fleetStatusName"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addFleetStatus()"
                              >Submit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addfleetstatus = false"
                              >Cancel</base-button
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </modal>
                </card>
              </div>
              <div class="col-lg-2"></div>
            </div>
          </tab-pane>

          <tab-pane label="Green Card">
            <div class="row">
              <div class="col-lg-3 d-flex">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Bin Type</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      height="450"
                      :data="binTypeData"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="100"
                        sortable
                        align="center"
                        label="Bin Type"
                        property="binname"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.edit = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                        <modal
                          :show.sync="modals.edit"
                          footer-classes="content-center"
                          type="notice"
                        >
                          <h3 slot="header" class="modal-title">Bin Type</h3>
                          <h5 class="text-left text-color">Edit bin type</h5>
                          <div class="row">
                            <div class="col-md-12">
                              <!-- content -->
                              <form @submit.prevent>
                                <div>
                                  <base-input
                                    type="text"
                                    label="Bin Type"
                                    placeholder="Bin Type"
                                    v-model="binType.binName"
                                  ></base-input>
                                  <base-input
                                    type="text"
                                    label="Bin Capacity"
                                    placeholder="Bin Capacity in L"
                                    v-model="binType.binCapacity"
                                  ></base-input>
                                  <base-button
                                    class="mt-3"
                                    native-type="submit"
                                    type="success"
                                    @click="editBinType()"
                                    >Submit</base-button
                                  >
                                  <base-button
                                    class="mt-3"
                                    type="danger"
                                    @click.native="modals.edit = false"
                                    >Cancel</base-button
                                  >
                                </div>
                              </form>
                            </div>
                          </div>
                        </modal>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      type="primary"
                      @click="emptyform"
                      @click.native="modals.addBinType = true"
                      >Add Bin</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <!-- add bin type modal -->
                  <modal
                    :show.sync="modals.addBinType"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Bin Type</h3>
                    <h5 class="text-left text-color">Register new bin type</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <form @submit.prevent>
                            <div>
                              <base-input
                                type="text"
                                label="Bin Type"
                                placeholder="Bin Type"
                                v-model="binType.binName"
                              ></base-input>
                              <base-input
                                type="text"
                                label="Bin Capacity"
                                placeholder="Bin Capacity in L"
                                v-model="binType.binCapacity"
                              ></base-input>
                              <base-button
                                class="mt-3"
                                native-type="submit"
                                type="success"
                                @click="addBinType()"
                                >Add</base-button
                              >
                              <base-button
                                class="mt-3"
                                type="danger"
                                @click.native="modals.addBinType = false"
                                >Cancel</base-button
                              >
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
              <div class="col-lg-3 d-flex">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Inspection Status</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="inspStat"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        v-if="false"
                        property="statid"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Status Name"
                        property="statname"
                      ></el-table-column>
                      <el-table-column min-width="100" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editInspStat = true"
                              @click="getInspStatRow(props.$index, props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>

                          <!-- <base-button
                            @click.native="deleteInspStat(props.$index, props.row)"
                            class="remove btn-link"
                            type="danger"
                            size="sm"
                            icon
                          >
                            <i class="tim-icons icon-simple-remove"></i>
                          </base-button>-->
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="emptyform()"
                      @click.native="
                        modals.addInspStat = true;
                        newInspName = '';
                      "
                      type="primary"
                      >Add Inspection Status</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                </card>
              </div>

              <!-- MODAL TO ADD INSPECTION STATUS -->
              <modal
                :show.sync="modals.addInspStat"
                footer-classes="justify-content-center"
                type="notice"
              >
                <h3 slot="header" class="modal-title">Inspection Status</h3>
                <h5 class="text-left text-color">Add Inspection Status</h5>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div>
                        <base-input
                          type="text"
                          label="Inspection Name"
                          placeholder="Inspection Name"
                          v-model="newInspName"
                        ></base-input>
                        <base-button
                          class="mt-3"
                          native-type="submit"
                          type="success"
                          @click="addInspStat()"
                          >Add</base-button
                        >
                        <base-button
                          class="mt-3"
                          type="danger"
                          @click.native="modals.addInspStat = false"
                          >Cancel</base-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="footer" class="justify-content-center"></div>
              </modal>

              <!-- MODAL TO EDIT INSPECTION STATUS -->
              <modal
                :show.sync="modals.editInspStat"
                footer-classes="justify-content-center"
                type="notice"
              >
                <h3 slot="header" class="modal-title">Inspection Status</h3>
                <h5 class="text-left text-color">Edit Inspection Status</h5>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div>
                        <base-input
                          type="text"
                          placeholder="Cause Name"
                          label="Cause Name"
                          v-model="newInspName"
                        ></base-input>
                        <base-button
                          class="mt-3"
                          native-type="submit"
                          type="success"
                          @click="editInspStat()"
                          >Edit</base-button
                        >
                        <base-button
                          class="mt-3"
                          type="danger"
                          @click.native="modals.editInspStat = false"
                          >Cancel</base-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="footer" class="justify-content-center"></div>
              </modal>

              <!-- TEMPORARY DISABLE DUE TO CHANGE OF BUSINESS LOGIC -->
              <!-- <div class="col-lg-3 d-flex">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Bin Status</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table :data="binStatusData">
                      <el-table-column
                        min-width="140"
                        sortable
                        align="center"
                        label="Bin Status"
                        property="statusname"
                      ></el-table-column>
                      <el-table-column min-width="95" label="Actions">
                        <div slot-scope="props">
                          <base-button
                            @click.native="modals.editBinStatus = true"
                            @click="getRow(props.row)"
                            class="edit btn-link"
                            type="success"
                            size="sm"
                            icon
                          >
                            <i class="tim-icons icon-pencil"></i>
                          </base-button>

                          <base-button
                            @click="deleteStatus(props.$index, props.row)"
                            class="remove btn-link"
                            type="danger"
                            size="sm"
                            icon
                          >
                            <i class="tim-icons icon-simple-remove"></i>
                          </base-button>
                        </div>
                        <modal
                          :show.sync="modals.editBinStatus"
                          footer-classes="justify-content-center"
                          type="notice"
                        >
                          <h3 slot="header" class="modal-title">Bin Status</h3>
                          <h5 class="text-left text-color">Edit bin status</h5>
                          <div class="modal-body">
                            <div class="row">
                              <div class="col-md-12">
                                <form @submit.prevent>
                                  <div>
                                    <base-input
                                      type="text"
                                      label="Bin Status"
                                      placeholder="Bin Status"
                                      v-model="binStatus.name"
                                    ></base-input>
                                    <base-button
                                      class="mt-3"
                                      native-type="submit"
                                      type="success"
                                      @click="editBinStatus()"
                                    >Add</base-button>
                                    <base-button
                                      class="mt-3"
                                      type="danger"
                                      @click.native="modals.addBinStatus = false"
                                    >Cancel</base-button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div slot="footer" class="justify-content-center"></div>
                        </modal>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      type="primary"
                      @click.native="modals.addBinStatus = true"
                    >Add Status</base-button>
                  </div>
                  <modal
                    :show.sync="modals.addBinStatus"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Bin Status</h3>
                    <h5 class="text-left text-color">Register new bin status</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <form @submit.prevent>
                            <div>
                              <base-input
                                type="text"
                                label="Bin Status"
                                placeholder="Bin Status"
                                v-model="binStatus.name"
                              ></base-input>
                              <base-button
                                class="mt-3"
                                native-type="submit"
                                type="success"
                                @click="addBinStatus()"
                              >Add</base-button>
                              <base-button
                                class="mt-3"
                                type="danger"
                                @click.native="modals.addBinStatus = false"
                              >Cancel</base-button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>-->
              <div class="col-lg-3 d-flex">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Region</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      height="450"
                      :data="regionData"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="140"
                        sortable
                        align="center"
                        label="Region"
                        property="region"
                      ></el-table-column>
                      <el-table-column min-width="95" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editRegion = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                          <!-- <base-button
                            @click="deleteRegion(props.$index, props.row)"
                            class="remove btn-link"
                            type="danger"
                            size="sm"
                            icon
                          >
                            <i class="tim-icons icon-simple-remove"></i>
                          </base-button>-->
                        </div>
                        <!-- add bin status modal -->
                        <modal
                          :show.sync="modals.editRegion"
                          footer-classes="justify-content-center"
                          type="notice"
                        >
                          <h3 slot="header" class="modal-title">Region</h3>
                          <h5 class="text-left text-color">Edit Region</h5>
                          <div class="modal-body">
                            <div class="row">
                              <div class="col-md-12">
                                <form @submit.prevent>
                                  <div>
                                    <base-input
                                      type="text"
                                      label="Region Name"
                                      placeholder="Region Name"
                                      v-model="region.name"
                                    ></base-input>
                                    <base-button
                                      class="mt-3"
                                      native-type="submit"
                                      type="success"
                                      @click="editRegion()"
                                      >Submit</base-button
                                    >
                                    <base-button
                                      class="mt-3"
                                      type="danger"
                                      @click.native="modals.editRegion = false"
                                      >Cancel</base-button
                                    >
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div
                            slot="footer"
                            class="justify-content-center"
                          ></div>
                        </modal>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      type="primary"
                      @click="emptyform()"
                      @click.native="modals.addRegion = true"
                      >Add Region</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <!-- add bin status modal -->
                  <modal
                    :show.sync="modals.addRegion"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Region</h3>
                    <h5 class="text-left text-color">Register new region</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <form @submit.prevent>
                            <div>
                              <base-input
                                type="text"
                                label="Region"
                                placeholder="Region"
                                v-model="region.name"
                              ></base-input>
                              <base-button
                                class="mt-3"
                                native-type="submit"
                                type="success"
                                @click="addRegion()"
                                >Add</base-button
                              >
                              <base-button
                                class="mt-3"
                                type="danger"
                                @click.native="modals.addRegion = false"
                                >Cancel</base-button
                              >
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
              <div class="col-lg-3 d-flex">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Route</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      height="450"
                      :data="routeData"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="140"
                        sortable
                        align="center"
                        label="Route"
                        property="route"
                      ></el-table-column>
                      <el-table-column min-width="95" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editRoute = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                          <!-- <base-button
                            @click="deleteRoute(props.$index, props.row)"
                            class="remove btn-link"
                            type="danger"
                            size="sm"
                            icon
                          >
                            <i class="tim-icons icon-simple-remove"></i>
                          </base-button>-->
                        </div>
                        <!-- add bin status modal -->
                        <modal
                          :show.sync="modals.editRoute"
                          footer-classes="justify-content-center"
                          type="notice"
                        >
                          <h3 slot="header" class="modal-title">Route</h3>
                          <h5 class="text-left text-color">
                            Update route info
                          </h5>
                          <div class="modal-body">
                            <div class="row">
                              <div class="col-md-12">
                                <form @submit.prevent>
                                  <div>
                                    <base-input
                                      type="text"
                                      label="Route"
                                      placeholder="Route"
                                      v-model="route.name"
                                    ></base-input>
                                    <base-input
                                      type="text"
                                      label="Region"
                                      placeholder="Region"
                                      v-model="route.region"
                                    >
                                      <el-select
                                        v-model="route.region"
                                        class="select-success"
                                      >
                                        <el-option
                                          v-for="option in regionOption"
                                          class="select-success"
                                          :value="option.value"
                                          :label="option.label"
                                          :key="option.label"
                                        ></el-option>
                                      </el-select>
                                    </base-input>
                                    <base-button
                                      class="mt-3"
                                      native-type="submit"
                                      type="success"
                                      @click="editRoute()"
                                      >Submit</base-button
                                    >
                                    <base-button
                                      class="mt-3"
                                      type="danger"
                                      @click.native="modals.editRoute = false"
                                      >Cancel</base-button
                                    >
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div
                            slot="footer"
                            class="justify-content-center"
                          ></div>
                        </modal>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      type="primary"
                      @click="emptyform()"
                      @click.native="modals.addRoute = true"
                      >Add Route</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <!-- add bin status modal -->
                  <modal
                    :show.sync="modals.addRoute"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Route</h3>
                    <h5 class="text-left text-color">Register Route</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <form @submit.prevent>
                            <div>
                              <base-input
                                type="text"
                                label="Route"
                                placeholder="Route"
                                v-model="route.name"
                              ></base-input>
                              <base-input
                                type="text"
                                label="Region"
                                placeholder="Region"
                                v-model="route.region"
                              >
                                <el-select
                                  v-model="route.region"
                                  class="select-success"
                                >
                                  <el-option
                                    v-for="option in regionOption"
                                    class="select-success"
                                    :value="option.value"
                                    :label="option.label"
                                    :key="option.label"
                                  ></el-option>
                                </el-select>
                              </base-input>
                              <base-button
                                class="mt-3"
                                native-type="submit"
                                type="success"
                                @click="addRoute()"
                                >Add</base-button
                              >
                              <base-button
                                class="mt-3"
                                type="danger"
                                @click.native="modals.addRoute = false"
                                >Cancel</base-button
                              >
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
            </div>
          </tab-pane>
          <!-- INCIDENT SETTINGS -->
          <tab-pane label="Incident">
            <div class="row">
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Incident Type</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="incidentType"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        v-if="false"
                        property="InTypeID"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Indident Name"
                        property="incidentname"
                      ></el-table-column>
                      <el-table-column
                        v-if="false"
                        property="jkkp"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editIncident = true"
                              @click="getIncidentRow(props.$index, props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addIncident = true;
                        newIncidentName = '';
                        jkkpOption.selectJKKP = '';
                      "
                      type="primary"
                      >Add Incident Type</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Accident Type</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="accidentType"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        v-if="false"
                        property="AcTypeID"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Accident Name"
                        property="acctypename"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editAccidentType = true"
                              @click="
                                getAccidentTypeRow(props.$index, props.row)
                              "
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addAccidentType = true;
                        newAccidentType = '';
                      "
                      type="primary"
                      >Add Accident Type</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Accident Class</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="accidentClass"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        v-if="false"
                        property="AcClassID"
                      ></el-table-column>
                      <el-table-column
                        v-if="false"
                        min-width="150"
                        sortable
                        align="center"
                        label="Class No"
                        property="acclassno"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Class Name"
                        property="acclassname"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editAccidentClass = true"
                              @click="
                                getAccidentClassRow(props.$index, props.row)
                              "
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addAccidentClass = true;
                        newAccClassNo = '';
                        newAccClassName = '';
                      "
                      type="primary"
                      >Add Accident Class</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Accident Cause</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="accidentCause"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        v-if="false"
                        property="AcCauseID"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Cause Name"
                        property="accausename"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editAccidentCause = true"
                              @click="
                                getAccidentCauseRow(props.$index, props.row)
                              "
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addAccidentCause = true;
                        newAccCauseName = '';
                      "
                      type="primary"
                      >Add Accident Cause</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                </card>
              </div>
            </div>

            <!-- MODAL TO ADD INCIDENT TYPE -->
            <modal
              :show.sync="modals.addIncident"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Incident</h3>
              <h5 class="text-left text-color">Add Incident Type</h5>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <base-input
                        type="text"
                        label="Incident Name"
                        v-model="newIncidentName"
                      ></base-input>
                      <base-input type="text" label="JKKP Form">
                        <el-select
                          class="select-info"
                          v-model="jkkpOption.selectJKKP"
                        >
                          <el-option
                            v-for="option in jkkpOption.jkkp"
                            class="select-info"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </el-select>
                      </base-input>
                      <base-button
                        class="mt-3"
                        native-type="submit"
                        type="success"
                        @click="addIncident()"
                        >Add</base-button
                      >
                      <base-button
                        class="mt-3"
                        type="danger"
                        @click.native="modals.addIncident = false"
                        >Cancel</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>

            <!-- MODAL TO EDIT INCIDENT TYPE -->
            <modal
              :show.sync="modals.editIncident"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Incident</h3>
              <h5 class="text-left text-color">Edit Incident Type</h5>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <base-input
                        type="text"
                        label="Incident Name"
                        v-model="newIncidentName"
                      ></base-input>
                      <base-input type="text" label="JKKP Form">
                        <el-select
                          class="select-info"
                          v-model="jkkpOption.selectJKKP"
                        >
                          <el-option
                            v-for="option in jkkpOption.jkkp"
                            class="select-info"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </el-select>
                      </base-input>
                      <base-button
                        class="mt-3"
                        native-type="submit"
                        type="success"
                        @click="editIncident()"
                        >Edit</base-button
                      >
                      <base-button
                        class="mt-3"
                        type="danger"
                        @click.native="modals.editIncident = false"
                        >Cancel</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>

            <!-- MODAL TO ADD ACCIDENT TYPE -->
            <modal
              :show.sync="modals.addAccidentType"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Accident</h3>
              <h5 class="text-left text-color">Add Accident Type</h5>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <base-input
                        type="text"
                        label="Accident Name"
                        v-model="newAccidentType"
                      ></base-input>
                      <base-button
                        class="mt-3"
                        native-type="submit"
                        type="success"
                        @click="addAccidentType()"
                        >Add</base-button
                      >
                      <base-button
                        class="mt-3"
                        type="danger"
                        @click.native="modals.addAccidentType = false"
                        >Cancel</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>

            <!-- MODAL TO EDIT ACCIDENT TYPE -->
            <modal
              :show.sync="modals.editAccidentType"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Accident</h3>
              <h5 class="text-left text-color">Edit Accident Type</h5>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <base-input
                        type="text"
                        label="Accident Type"
                        v-model="newAccidentType"
                      ></base-input>
                      <base-button
                        class="mt-3"
                        native-type="submit"
                        type="success"
                        @click="editAccidentType()"
                        >Edit</base-button
                      >
                      <base-button
                        class="mt-3"
                        type="danger"
                        @click.native="modals.editAccidentType = false"
                        >Cancel</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>

            <!-- MODAL TO ADD ACCIDENT CLASS -->
            <modal
              :show.sync="modals.addAccidentClass"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Accident</h3>
              <h5 class="text-left text-color">Add Accident Class</h5>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <base-input
                        type="number"
                        label="Class No"
                        v-model="newAccClassNo"
                      ></base-input>
                      <base-input
                        type="text"
                        label="Class Name"
                        v-model="newAccClassName"
                      ></base-input>
                      <base-button
                        class="mt-3"
                        native-type="submit"
                        type="success"
                        @click="addAccidentClass()"
                        >Add</base-button
                      >
                      <base-button
                        class="mt-3"
                        type="danger"
                        @click.native="modals.addAccidentClass = false"
                        >Cancel</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>

            <!-- MODAL TO EDIT ACCIDENT CLASS -->
            <modal
              :show.sync="modals.editAccidentClass"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Accident</h3>
              <h5 class="text-left text-color">Edit Accident Class</h5>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <base-input
                        type="number"
                        label="Class No"
                        v-model="newAccClassNo"
                      ></base-input>
                      <base-input
                        type="text"
                        label="Class Name"
                        v-model="newAccClassName"
                      ></base-input>
                      <base-button
                        class="mt-3"
                        native-type="submit"
                        type="success"
                        @click="editAccidentClass()"
                        >Edit</base-button
                      >
                      <base-button
                        class="mt-3"
                        type="danger"
                        @click.native="modals.editAccidentClass = false"
                        >Cancel</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>

            <!-- MODAL TO ADD ACCIDENT CAUSE -->
            <modal
              :show.sync="modals.addAccidentCause"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Accident</h3>
              <h5 class="text-left text-color">Add Accident Cause</h5>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <base-input
                        type="text"
                        label="Cause Name"
                        v-model="newAccCauseName"
                      ></base-input>
                      <base-button
                        class="mt-3"
                        native-type="submit"
                        type="success"
                        @click="addAccidentCause()"
                        >Add</base-button
                      >
                      <base-button
                        class="mt-3"
                        type="danger"
                        @click.native="modals.addAccidentCause = false"
                        >Cancel</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>

            <!-- MODAL TO EDIT ACCIDENT CAUSE -->
            <modal
              :show.sync="modals.editAccidentCause"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Accident</h3>
              <h5 class="text-left text-color">Edit Accident Cause</h5>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <base-input
                        type="text"
                        label="Cause Name"
                        v-model="newAccCauseName"
                      ></base-input>
                      <base-button
                        class="mt-3"
                        native-type="submit"
                        type="success"
                        @click="editAccidentCause()"
                        >Edit</base-button
                      >
                      <base-button
                        class="mt-3"
                        type="danger"
                        @click.native="modals.editAccidentCause = false"
                        >Cancel</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>
          </tab-pane>
          <tab-pane label="Asset">
            <div class="row">
              <div class="col-lg-6">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Site</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="site"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Site"
                        property="siteName"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Latitude"
                        property="lat"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Longitude"
                        property="long"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editSite = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addSite = true;
                        sitename = '';
                      "
                      type="primary"
                      >Add Site</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                </card>
                <!-- MODAL TO ADD SITE -->
                <modal
                  :show.sync="modals.addSite"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <h3 slot="header" class="modal-title">Site</h3>
                  <h5 class="text-left text-color">Site Management</h5>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <div>
                          <base-input
                            type="text"
                            label="Site Name"
                            v-model="siteName"
                            placeholder="Site Name"
                          ></base-input>
                          <base-input
                            type="number"
                            label="Latitude"
                            v-model="lat"
                            placeholder="Latitude"
                          ></base-input>
                          <base-input
                            type="number"
                            label="Longitude"
                            v-model="long"
                            placeholder="Longitude"
                          ></base-input>
                          <base-button
                            class="mt-3"
                            native-type="submit"
                            type="success"
                            @click="addSite()"
                            >Add</base-button
                          >
                          <base-button
                            class="mt-3"
                            type="danger"
                            @click.native="modals.addSite = false"
                            >Cancel</base-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div slot="footer" class="justify-content-center"></div>
                </modal>
                <!-- MODAL TO EDIT SITE -->
                <modal
                  :show.sync="modals.editSite"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <h3 slot="header" class="modal-title">Site</h3>
                  <h5 class="text-left text-color">Site Management</h5>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <div>
                          <base-input
                            type="text"
                            label="Site Name"
                            v-model="siteName"
                            placeholder="Site Name"
                          ></base-input>
                          <base-input
                            type="number"
                            label="Latitude"
                            v-model="lat"
                            placeholder="Latitude"
                          ></base-input>
                          <base-input
                            type="number"
                            label="Longitude"
                            v-model="long"
                            placeholder="Longitude"
                          ></base-input>
                          <base-button
                            class="mt-3"
                            native-type="submit"
                            type="success"
                            @click="editSite()"
                            >Site</base-button
                          >
                          <base-button
                            class="mt-3"
                            type="danger"
                            @click.native="modals.editSite = false"
                            >Cancel</base-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div slot="footer" class="justify-content-center"></div>
                </modal>
              </div>
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Owner</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="owner"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Owner"
                        property="owner"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editOwner = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addOwner = true;
                        ownerName = '';
                      "
                      type="primary"
                      >Add Owner</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <!-- MODAL TO ADD SITE -->
                  <modal
                    :show.sync="modals.addOwner"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Owner</h3>
                    <h5 class="text-left text-color">Owner Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Owner"
                              v-model="ownerName"
                              placeholder="Owner"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addOwner()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addOwner = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SITE -->
                  <modal
                    :show.sync="modals.editOwner"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Owner</h3>
                    <h5 class="text-left text-color">Owner Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Owner"
                              v-model="ownerName"
                              placeholder="Owner"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editOwner()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editOwner = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Cost Center</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="costcenter"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Cost Center"
                        property="costcenterName"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editCostCenter = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addCostCenter = true;
                        costcenterName = '';
                      "
                      type="primary"
                      >Add Cost Center</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <!-- MODAL TO ADD COST CENTER -->
                  <modal
                    :show.sync="modals.addCostCenter"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Cost Center</h3>
                    <h5 class="text-left text-color">Cost Center Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Cost Center"
                              v-model="costcenterName"
                              placeholder="Cost Center"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addCostCenter()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addCostCenter = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT COST CENTER -->
                  <modal
                    :show.sync="modals.editCostCenter"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Cost Center</h3>
                    <h5 class="text-left text-color">Cost Center Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Cost Center"
                              v-model="costcenterName"
                              placeholder="Cost Center"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editCostCenter()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editCostCenter = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
            </div>
          </tab-pane>
          <tab-pane label="Attendance">
            <div class="row">
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Service Area</h3>
                  </div>
                  <div class="col-lg-12">
                    <el-table
                      :data="servicearea"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Site"
                        property="areaName"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editServiceArea = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addServiceArea = true;
                        areaName = '';
                      "
                      type="primary"
                      >Add Service Area</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <!-- MODAL TO ADD SERVICE AREA -->
                  <modal
                    :show.sync="modals.addServiceArea"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Service Area</h3>
                    <h5 class="text-left text-color">
                      Service Area Management
                    </h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Service Area Name"
                              v-model="areaName"
                              placeholder="Service Area Name"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addServiceArea()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addServiceArea = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SERVICE AREA -->
                  <modal
                    :show.sync="modals.editServiceArea"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Service Area</h3>
                    <h5 class="text-left text-color">
                      Service Area Management
                    </h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Service Area Name"
                              v-model="areaName"
                              placeholder="Service Area Name"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editServiceArea()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editServiceArea = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
              <div class="col-lg-6">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Service Location</h3>
                  </div>
                  <div class="col-lg">
                    <el-table
                      :data="servicelocation"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Location Name"
                        property="locationName"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Latitude"
                        property="locationLatitude"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Longitude"
                        property="locationLongitude"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editServiceLocation = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <base-button
                      @click="
                        modals.addServiceLocation = true;
                        locationName = '';
                        locationLatitude = '';
                        locationLongitude = '';
                      "
                      type="primary"
                      >Add Service Location</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <!-- MODAL TO ADD SERVICE LOCATION -->
                  <modal
                    :show.sync="modals.addServiceLocation"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Service Location</h3>
                    <h5 class="text-left text-color">
                      Service Location Management
                    </h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Service Location Name"
                              v-model="locationName"
                              placeholder="Service Location Name"
                            ></base-input>
                            <base-input
                              type="number"
                              label="Latitude"
                              v-model="locationLatitude"
                              placeholder="Latitude"
                            ></base-input>
                            <base-input
                              type="number"
                              label="Longitude"
                              v-model="locationLongitude"
                              placeholder="Longitude"
                            ></base-input>

                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addServiceLocation()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addServiceLocation = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SERVICE LOCATION -->
                  <modal
                    :show.sync="modals.editServiceLocation"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Service Location</h3>
                    <h5 class="text-left text-color">
                      Service Location Management
                    </h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Service Location Name"
                              v-model="locationName"
                              placeholder="Service Location Name"
                            ></base-input>
                            <base-input
                              type="number"
                              label="Latitude"
                              v-model="locationLatitude"
                              placeholder="Latitude"
                            ></base-input>
                            <base-input
                              type="number"
                              label="Longitude"
                              v-model="locationLongitude"
                              placeholder="Longitude"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editServiceLocation()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editServiceLocation = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
            </div>
          </tab-pane>
          <tab-pane label="CEMS">
            <div class="row">
              <div class="col-lg-5">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>CEMS Limit</h3>
                  </div>
                  <div class="col-lg">
                    <!-- hmm -->
                    <el-table
                      :data="cemslimit"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Parameter"
                        property="parameter"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="DOE CEMS Limit"
                        property="limit"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Unit"
                        property="unit"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editCEMSLimit = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <!-- @click="
                        modals.addServiceLocation = true;
                        locationName = '';
                        locationLatitude = '';
                        locationLongitude = '';
                      " -->
                    <base-button
                      type="primary"
                      @click="modals.addCEMSLimit = true"
                      >Add CEMS Limit</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <modal
                    :show.sync="modals.addCEMSLimit"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">CEMS Limit</h3>
                    <h5 class="text-left text-color">CEMS Limit Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Parameter"
                              v-model="parameter"
                              placeholder="Parameter"
                            ></base-input>
                            <base-input
                              type="number"
                              label="DOE CEMS Limit"
                              v-model="limit"
                              placeholder="DOE CEMS Limit"
                            ></base-input>
                            <base-input
                              type="text"
                              label="Unit"
                              v-model="unit"
                              placeholder="Unit"
                            ></base-input>

                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addCEMSLimit()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addCEMSLimit = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SERVICE LOCATION -->
                  <modal
                    :show.sync="modals.editCEMSLimit"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">CEMS Limit</h3>
                    <h5 class="text-left text-color">CEMS Limit Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Parameter"
                              v-model="parameter"
                              placeholder="Parameter"
                              disabled
                            ></base-input>
                            <base-input
                              type="number"
                              label="DOE CEMS Limit"
                              v-model="limit"
                              placeholder="DOE CEMS Limit"
                            ></base-input>
                            <base-input
                              type="text"
                              label="Unit"
                              v-model="unit"
                              placeholder="Unit"
                              disabled
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editCEMSLimit()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editCEMSLimit = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
              <div class="col-lg-5">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Site</h3>
                  </div>
                  <div class="col-lg">
                    <!-- hmm -->
                    <el-table
                      :data="cemssites"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Site Name"
                        property="cemssitename"
                      ></el-table-column>
                      <el-table-column min-width="90" label="Actions">
                        <div slot-scope="props">
                          <el-tooltip
                            content="Edit"
                            placement="bottom"
                            effect="light"
                          >
                            <base-button
                              @click.native="modals.editCEMSSite = true"
                              @click="getRow(props.row)"
                              class="edit btn-link"
                              type="info"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </el-tooltip>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <!-- @click="
                        modals.addServiceLocation = true;
                        locationName = '';
                        locationLatitude = '';
                        locationLongitude = '';
                      " -->
                    <base-button
                      type="primary"
                      @click="modals.addCEMSSite = true"
                      >Add CEMS Site</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <modal
                    :show.sync="modals.addCEMSSite"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">CEMS Site</h3>
                    <h5 class="text-left text-color">CEMS Site Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Site Name"
                              v-model="cemssitename"
                              placeholder="Site Name"
                            ></base-input>

                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addCEMSSite()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addCEMSSite = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SERVICE LOCATION -->
                  <modal
                    :show.sync="modals.editCEMSSite"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">CEMS Site</h3>
                    <h5 class="text-left text-color">CEMS Site Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Parameter"
                              v-model="cemssitename"
                              placeholder="Site Name"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editCEMSSite()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editCEMSSite = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
            </div>
          </tab-pane>
          <tab-pane label="Weightbridge">
            <div class="row">
              <div class="col-lg-5">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Supplier (Collector)</h3>
                  </div>
                  <div class="col-lg">
                    <!-- hmm -->
                    <el-table
                      :data="suppliers"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Supplier Code"
                        property="suppliercode"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Supplier Name"
                        property="suppliername"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Private Contractor"
                        property="isprivatecontractor"
                        ><div slot-scope="{ row }">
                          <el-switch
                            v-model="row.isprivatecontractor"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            disabled
                          >
                          </el-switch>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <!-- @click="
                        modals.addServiceLocation = true;
                        locationName = '';
                        locationLatitude = '';
                        locationLongitude = '';
                      " -->
                    <base-button
                      type="primary"
                      @click="modals.addSupplier = true"
                      >Add Supplier</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <modal
                    :show.sync="modals.addSupplier"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">
                      Supplier (Collector)
                    </h3>
                    <h5 class="text-left text-color">
                      Fill in all item to create new supplier.
                    </h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Supplier Code"
                              v-model="suppliercode"
                              placeholder="Supplier Code"
                            ></base-input>
                            <base-input
                              type="text"
                              label="Supplier Name"
                              v-model="suppliername"
                              placeholder="Supplier Name"
                            ></base-input>
                            <base-input
                              type="text"
                              label="Private Contractor"
                              v-model="privatecontractor"
                              placeholder="Private Contractor"
                              ><el-switch
                                v-model="privatecontractor"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                active-text="true"
                                inactive-text="false"
                              >
                              </el-switch>
                            </base-input>

                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addSupplier()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addSupplier = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SERVICE LOCATION -->
                  <modal
                    :show.sync="modals.editCEMSLimit"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">CEMS Limit</h3>
                    <h5 class="text-left text-color">CEMS Limit Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Parameter"
                              v-model="parameter"
                              placeholder="Parameter"
                              disabled
                            ></base-input>
                            <base-input
                              type="number"
                              label="DOE CEMS Limit"
                              v-model="limit"
                              placeholder="DOE CEMS Limit"
                            ></base-input>
                            <base-input
                              type="text"
                              label="Unit"
                              v-model="unit"
                              placeholder="Unit"
                              disabled
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editCEMSLimit()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editCEMSLimit = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Destination (Site)</h3>
                  </div>
                  <div class="col-lg">
                    <!-- hmm -->
                    <el-table
                      :data="destinations"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Destination Code"
                        property="destinationcode"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Destination Name"
                        property="destinationname"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <!-- @click="
                        modals.addServiceLocation = true;
                        locationName = '';
                        locationLatitude = '';
                        locationLongitude = '';
                      " -->
                    <base-button
                      type="primary"
                      @click="modals.addDestination = true"
                      >Add Destination</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <modal
                    :show.sync="modals.addDestination"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">
                      Destination (Site)
                    </h3>
                    <h5 class="text-left text-color">
                      Fill in all the information to register new destination
                    </h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Destination Code"
                              v-model="destinationcode"
                              placeholder="Destination Code"
                            ></base-input>
                            <base-input
                              type="text"
                              label="Destination Name"
                              v-model="destinationname"
                              placeholder="Destination Name"
                            ></base-input>

                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addDestination()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addCEMSSite = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SERVICE LOCATION -->
                  <!-- <modal
                    :show.sync="modals.editCEMSSite"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">CEMS Site</h3>
                    <h5 class="text-left text-color">CEMS Site Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Parameter"
                              v-model="cemssitename"
                              placeholder="Site Name"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editCEMSSite()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editCEMSSite = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal> -->
                </card>
              </div>
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Product Type</h3>
                  </div>
                  <div class="col-lg">
                    <!-- hmm -->
                    <el-table
                      :data="producttypes"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Product Type Code"
                        property="producttypecode"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Product Type Name"
                        property="producttypename"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <!-- @click="
                        modals.addServiceLocation = true;
                        locationName = '';
                        locationLatitude = '';
                        locationLongitude = '';
                      " -->
                    <base-button
                      type="primary"
                      @click="modals.addproducttype = true"
                      >Add Product Type</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <modal
                    :show.sync="modals.addproducttype"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Product Type</h3>
                    <h5 class="text-left text-color">
                      Fill in all the information to create new product type.
                    </h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Product Type Code"
                              v-model="producttypecode"
                              placeholder="Product Type Code"
                            ></base-input>
                            <base-input
                              type="text"
                              label="Product Type Name"
                              v-model="producttypename"
                              placeholder="Product Type Name"
                            ></base-input>

                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addProductTypes()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addproducttype = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SERVICE LOCATION -->
                  <modal
                    :show.sync="modals.editCEMSSite"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">CEMS Site</h3>
                    <h5 class="text-left text-color">CEMS Site Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Parameter"
                              v-model="cemssitename"
                              placeholder="Site Name"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editCEMSSite()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editCEMSSite = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="setting">
                  <div class="col-lg-12 text-center">
                    <h3>Transport Code</h3>
                  </div>
                  <div class="col-lg">
                    <!-- hmm -->
                    <el-table
                      :data="transports"
                      height="450"
                      :header-cell-style="{
                        background: 'transparent',
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                      :cell-style="{
                        border: 'none',
                        borderBottom: '0.5px solid #3d3f51',
                      }"
                    >
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Transport Code"
                        property="transportcode"
                      ></el-table-column>
                      <el-table-column
                        min-width="150"
                        sortable
                        align="center"
                        label="Transport Code Name"
                        property="transportcodename"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <div class="col text-center">
                    <!-- @click="
                        modals.addServiceLocation = true;
                        locationName = '';
                        locationLatitude = '';
                        locationLongitude = '';
                      " -->
                    <base-button
                      type="primary"
                      @click="modals.addtransport = true"
                      >Add Transport Code</base-button
                    >
                  </div>
                  <div class="d-flex justify-content-center spinner" v-if="loading">
                <circle-8></circle-8>
              </div>
                  <modal
                    :show.sync="modals.addtransport"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">Transport Code</h3>
                    <h5 class="text-left text-color">
                      Fill in the information to create new transport code.
                    </h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Transport Code"
                              v-model="transportcode"
                              placeholder="Transport Code"
                            ></base-input>
                            <base-input
                              type="text"
                              label="Transport Code Name"
                              v-model="transportcodename"
                              placeholder="Transport Code Name"
                            ></base-input>

                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="addTransport()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addtransport = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                  <!-- MODAL TO EDIT SERVICE LOCATION -->
                  <modal
                    :show.sync="modals.editCEMSSite"
                    footer-classes="justify-content-center"
                    type="notice"
                  >
                    <h3 slot="header" class="modal-title">CEMS Site</h3>
                    <h5 class="text-left text-color">CEMS Site Management</h5>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <base-input
                              type="text"
                              label="Parameter"
                              v-model="cemssitename"
                              placeholder="Site Name"
                            ></base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="editCEMSSite()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editCEMSSite = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="justify-content-center"></div>
                  </modal>
                </card>
              </div>
            </div>
          </tab-pane>
        </tabs>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Switch } from "element-ui";
import { Select, Option } from "element-ui";
import { Modal, TabPane, Tabs } from "src/components";
import axios from "axios";
import swal from "sweetalert2";
import ReplacementReportVue from "../Fleet/ReportPage/ReplacementReport.vue";
import { Circle8 } from "vue-loading-spinner";

// const hawau = window.sessionStorage.getItem("tab-current")
export default {
  components: {
    Circle8,
    TabPane,
    Tabs,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Switch.name]: Switch,
    Modal,
  },
  data() {
    return {
      loading: false,
      // cost center
      costcenter: [],
      costcenterName: "",
      // owner
      owner: [],
      ownerName: "",
      ownerID: "",
      // site
      site: [],
      siteID: "",
      siteName: "",
      lat: "",
      long: "",
      // Department
      departmentName: "",
      departmentID: "",
      // Fleet Status
      fleetStatusName: "",
      fleetStatusID: "",
      // service area
      servicearea: [],
      areaName: "",
      areaID: "",
      // Service Location
      servicelocation: [],
      locationID: "",
      locationName: "",
      locationLatitude: "",
      locationLongitude: "",
      // ######################################################################## (DZAF) INCIDENT ######################################################################### //
      incidentType: [],
      newIncidentName: "",
      selectedIncident: null,
      incidentIndex: null,
      jkkpOption: {
        selectJKKP: "",
        jkkp: [
          {
            value: 6,
            label: "6",
          },
          {
            value: 7,
            label: "7",
          },
        ],
      },

      accidentType: [],
      newAccidentType: "",
      selectedAccidentType: null,
      accidentTypeIndex: null,

      accidentClass: [],
      newAccClassName: "",
      newAccClassNo: "",
      selectedAccidentClass: null,
      accidentClassIndex: null,

      accidentCause: [],
      newAccCauseName: "",
      selectedAccidentCause: null,
      accidentCauseIndex: null,

      pvStepType: [],
      newPvStepName: "",
      selectedPvStep: null,
      pvStepIndex: null,

      inspStat: [],
      newInspName: "",
      selectedInspname: null,
      inspNameIndex: null,

      cemssites: [],
      cemssitename: "",
      cemssiteid: "",

      // ################################################################################################################################################################## //

      modals: {
        addBinType: false,
        edit: false,
        addBinStatus: false,
        editBinStatus: false,
        addRegion: false,
        editRegion: false,
        addRoute: false,
        editRoute: false,
        addIncident: false,
        editIncident: false,
        addAccidentType: false,
        editAccidentType: false,
        addAccidentClass: false,
        editAccidentClass: false,
        addAccidentCause: false,
        editAccidentCause: false,
        addPvStepType: false,
        editPvStepType: false,
        addInspStat: false,
        editInspStat: false,
        // department
        adddepartment: false,
        editdepartment: false,
        // fleet status
        addfleetstatus: false,
        editfleetstatus: false,
        // site
        addSite: false,
        editSite: false,
        // owner
        addOwner: false,
        editOwner: false,
        // cost center
        editCostCenter: false,
        addCostCenter: false,
        // service area
        addServiceArea: false,
        editServiceArea: false,
        // service location
        addServiceLocation: false,
        editServiceLocation: false,
        // CEMS Limit
        addCEMSLimit: false,
        editCEMSLimit: false,
        // CEMS Site
        addCEMSSite: false,
        editCEMSSite: false,
        // weightbridge
        addSupplier: false,
        addDestination: false,
        addproducttype: false,
        addtransport: false,
      },

      fleetAttributesData: [
        {
          fleetAttributes: "Total Vehicle",
          check: false,
        },
        {
          fleetAttributes: "Replacement",
          check: false,
        },
        {
          fleetAttributes: "Requirement",
          check: false,
        },
        {
          fleetAttributes: "Availability",
          check: false,
        },
        {
          fleetAttributes: "Percentage Availability",
          check: false,
        },
        {
          fleetAttributes: "Breakdown",
          check: false,
        },
        {
          fleetAttributes: "Unserviced Vehicle",
          check: false,
        },
      ],
      fleetStatusData: [
        {
          fleetStatus: "Available",
        },
        {
          fleetStatus: "Breakdown",
        },
        {
          fleetStatus: "Replacement",
        },
      ],
      //////////////////////////////////////bin type/////////////////////////////////////////////////
      binType: {
        binName: "",
        binCapacity: "",
        binTypeId: "",
      },
      binTypeData: [],
      /////////////////////////////////////////bin status/////////////////////////////////////////
      binStatus: {
        name: "",
        id: "",
      },
      binStatusData: [],
      departmentData: [
        {
          department: "ICWS",
        },
        {
          department: "WMF",
        },
        {
          department: "IFM",
        },
        {
          department: "HR",
        },
      ],
      //////////////////////////////////////region///////////////////////////////////////
      regionData: [],
      region: {
        name: "",
        id: "",
      },
      routeData: [],
      //////////////////////////////////////route////////////////////////////
      route: {
        name: "",
        id: "",
        region: "",
        regionID: "",
      },
      regionOption: [],
      // CEMS
      cemslimit: [
        {
          parameter: "SO2",
          limit: 50,
          unit: "mg/m3",
        },
        {
          parameter: "NOx",
          limit: 200,
          unit: "mg/m3",
        },
        {
          parameter: "CO",
          limit: 50,
          unit: "mg/m3",
        },
        {
          parameter: "HCL",
          limit: 40,
          unit: "mg/m3",
        },
        {
          parameter: "O2",
          limit: "N/A",
          unit: "%",
        },
        {
          parameter: "HF",
          limit: 1,
          unit: "mg/m3",
        },
        {
          parameter: "NMVOC",
          limit: 10,
          unit: "mg/m3",
        },
        {
          parameter: "OPACITY",
          limit: 20,
          unit: "%",
        },
        {
          parameter: "TOTAL PM",
          limit: 100,
          unit: "mg/m3",
        },
      ],
      parameter: "",
      limit: "",
      unit: "",
      ///////////////////////////////////////// INCIDENT TYPE /////////////////////////////
      //weightbridge
      suppliers: [],
      suppliercode: "",
      suppliername: "",
      privatecontractor: false,
      destinations: [],
      destinationcode: "",
      destinationname: "",
      producttypes: [],
      producttypecode: "",
      producttypename: "",
      transports: [],
      transportcode: "",
      transportcodename: "",
      // TabData: window.sessionStorage.getItem("tab-current")
      currenttabs: "",
    };
  },

  methods: {
    getCurrent(e) {
      console.log(e);
      this.currenttabs = e;
    },
    // cost center
    getCostCenter() {
      this.costcenter = [];
      this.$http.get(":9996/api/v1/manage/cost").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              costcenterName: response[i].CostCenterName,
              costcenterID: response[i].CostCenterID,
            };
            this.costcenter.push(obj);
          }
          this.loading = false;
        }
      });
    },
    addCostCenter() {
      if (this.costcenterName == "") {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      } else {
        let payload = {
          CostCenterName: this.costcenterName,
        };
        console.log(payload);

        this.$http.post(":9996/api/v1/manage/cost", payload).then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.getCostCenter();
            this.modals.addCostCenter = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.addCostCenter = false;
          }
        });
      }
    },
    editCostCenter() {
      console.log(this.costcenterID, this.costcenterName);
      let payload = {
        CostCenterName: this.costcenterName,
      };

      this.$http
        .put(":9996/api/v1/manage/cost/" + this.costcenterID, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.getCostCenter();
            this.modals.editCostCenter = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editCostCenter = false;
          }
        });
    },
    // site
    getSite() {
      this.site = [];
      this.$http.get(":9996/api/v1/manage/site").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              siteID: response[i].SiteID,
              siteName: response[i].SiteName,
              lat: response[i].Latitude,
              long: response[i].Longitude,
            };
            this.site.push(obj);
          }
        }
      });
    },
    addSite() {
      console.log(this.siteName, this.lat, this.long);
      if (this.siteName == "" || this.lat == "" || this.long == "") {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      } else {
        let payload = {
          SiteName: this.siteName,
          Latitude: parseFloat(this.lat),
          Longitude: parseFloat(this.long),
        };
        console.log(payload);
        this.$http.post(":9996/api/v1/manage/site", payload).then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.getSite();
            this.modals.addSite = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.addSite = false;
          }
        });
      }
    },
    editSite() {
      console.log(this.siteID, this.siteName, this.lat, this.long);

      let payload = {
        SiteName: this.siteName,
        Latitude: parseFloat(this.lat),
        Longitude: parseFloat(this.long),
      };

      this.$http
        .put(":9996/api/v1/manage/site/" + this.siteID, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.getSite();
            this.modals.editSite = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editSite = false;
          }
        });
    },
    // owner
    getOwner() {
      this.owner = [];
      this.$http.get(":9996/api/v1/manage/owner").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              owner: response[i].OwnedByName,
              ownerID: response[i].OwnedByID,
            };
            this.owner.push(obj);
          }
        }
      });
    },
    addOwner() {
      console.log(this.ownerName);
      let obj = {
        OwnedByName: this.ownerName,
      };
      this.$http.post(":9996/api/v1/manage/owner", obj).then((res) => {
        if (!res.error) {
          let response = res.message;
          swal({
            title: "Successful!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.getOwner();
          this.modals.addOwner = false;
        } else {
          swal({
            title: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.addOwner = false;
        }
      });
    },
    editOwner() {
      console.log(this.ownerID, this.ownerName);
      let payload = {
        OwnedByName: this.ownerName,
      };

      this.$http
        .put(":9996/api/v1/manage/owner/" + this.ownerID, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getOwner();
            this.modals.editOwner = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editOwner = false;
          }
        });
    },
    // ######################################################################## (DZAF) INCIDENT ######################################################################### //
    getIncident() {
      this.$http.get(":9994/api/v1/setting/incidentType").then((res) => {
        if (!res.error) {
          this.incidentType = res.message;
        }
      });
    },
    getIncidentRow(index, row) {
      this.incidentIndex = index;
      this.selectedIncident = row;
      this.newIncidentName = row.incidentname;
      this.jkkpOption.selectJKKP = row.jkkp;
    },
    addIncident() {
      if (this.newIncidentName == "" || this.jkkpOption.selectJKKP == "") {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });

        return;
      }

      let body = {
        incidentname: this.newIncidentName,
        jkkp: parseInt(this.jkkpOption.selectJKKP),
      };

      this.$http.post(":9994/api/v1/setting/incidentType", body).then((res) => {
        if (!res.error) {
          swal({
            title: "Successful!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });

          this.getIncident();
          this.modals.addIncident = false;
        } else {
          swal({
            title: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.addIncident = false;
        }
      });
    },
    editIncident() {
      let body;

      if (this.selectedIncident.incidentname == this.newIncidentName) {
        body = {
          jkkp: parseInt(this.jkkpOption.selectJKKP),
        };
      } else {
        body = {
          incidentname: this.newIncidentName,
          jkkp: parseInt(this.jkkpOption.selectJKKP),
        };
      }

      this.$http
        .put(
          `:9994/api/v1/setting/incidentType/${this.selectedIncident.InTypeID}`,
          body
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.incidentType[this.incidentIndex]["incidentname"] =
              this.newIncidentName;
            this.modals.editIncident = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editIncident = false;
          }
        });
    },
    // ######################################################################## (DZAF) ACCIDENT TYPE ######################################################################### //
    emptyform() {
      this.route.name = "";
      this.route.region = "";
      this.region.name = "";
      this.binType.binName = "";
      this.binType.binCapacity = "";
    },
    getAccidentType() {
      this.$http.get(":9994/api/v1/setting/accidentType").then((res) => {
        if (!res.error) {
          this.accidentType = res.message;
        }
      });
    },
    getAccidentTypeRow(index, row) {
      this.accidentTypeIndex = index;
      this.selectedAccidentType = row;
      this.newAccidentType = row.acctypename;
      // console.log(row);
    },
    addAccidentType() {
      if (this.newAccidentType == "") {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });

        return;
      }

      let body = {
        acctypename: this.newAccidentType,
      };

      this.$http.post(":9994/api/v1/setting/accidentType", body).then((res) => {
        if (!res.error) {
          swal({
            title: "Successful!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });

          this.getAccidentType();
          this.modals.addAccidentType = false;
        } else {
          swal({
            title: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.addAccidentType = false;
        }
      });
    },
    editAccidentType() {
      let body = {
        acctypename: this.newAccidentType,
      };

      this.$http
        .put(
          `:9994/api/v1/setting/accidentType/${this.selectedAccidentType.AcTypeID}`,
          body
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.accidentType[this.accidentTypeIndex]["acctypename"] =
              this.newAccidentType;

            this.modals.editAccidentType = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editAccidentType = false;
          }
        });
    },
    // ######################################################################## (DZAF) ACCIDENT CLASS ######################################################################### //
    getAccidentClass() {
      this.$http.get(":9994/api/v1/setting/accidentClass").then((res) => {
        if (!res.error) {
          this.accidentClass = res.message;
          this.loading = false;
        }
      });
    },
    getAccidentClassRow(index, row) {
      this.accidentClassIndex = index;
      this.selectedAccidentClass = row;
      this.newAccClassName = row.acclassname;
      this.newAccClassNo = parseInt(row.acclassno.split(" ")[1]);
    },
    addAccidentClass() {
      if (this.newAccClassName == "" || this.newAccClassNo == "") {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });

        return;
      }

      let body = {
        acclassno: `Class ${this.newAccClassNo}`,
        acclassname: this.acclassname,
      };

      this.$http
        .post(":9994/api/v1/setting/accidentClass", body)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.getAccidentClass();
            this.modals.addAccidentClass = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.addAccidentClass = false;
          }
        });
    },
    editAccidentClass() {
      let body;
      if (this.selectedAccidentClass.acclassname == this.newAccClassName) {
        body = {
          acclassno: `Class ${this.newAccClassNo}`,
        };
      } else {
        body = {
          acclassno: `Class ${this.newAccClassNo}`,
          acclassname: this.newAccClassName,
        };
      }

      this.$http
        .put(
          `:9994/api/v1/setting/accidentClass/${this.selectedAccidentClass.AcClassID}`,
          body
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.accidentClass[this.accidentClassIndex]["acclassname"] =
              this.newAccClassName;
            this.accidentClass[this.accidentClassIndex][
              "acclassno"
            ] = `Class ${this.newAccClassNo}`;

            this.modals.editAccidentClass = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editAccidentClass = false;
          }
        });
    },
    // ######################################################################## (DZAF) ACCIDENT CAUSE ######################################################################### //
    getAccidentCause() {
      this.$http.get(":9994/api/v1/setting/accidentCause").then((res) => {
        if (!res.error) {
          this.accidentCause = res.message;
        }
      });
    },
    getAccidentCauseRow(index, row) {
      this.accidentCauseIndex = index;
      this.selectedAccidentCause = row;
      this.newAccCauseName = row.accausename;
    },
    addAccidentCause() {
      if (this.newAccCauseName == "") {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });

        return;
      }

      let body = {
        accausename: this.newAccCauseName,
      };

      this.$http
        .post(":9994/api/v1/setting/accidentCause", body)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.getAccidentCause();
            this.modals.addAccidentCause = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.addAccidentCause = false;
          }
        });
    },
    editAccidentCause() {
      let body = {
        accausename: this.newAccCauseName,
      };

      this.$http
        .put(
          `:9994/api/v1/setting/accidentCause/${this.selectedAccidentCause.AcCauseID}`,
          body
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.accidentCause[this.accidentCauseIndex]["accausename"] =
              this.newAccCauseName;

            this.modals.editAccidentCause = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editAccidentCause = false;
          }
        });
    },

    // ######################################################################## (DZAF) PRECENTIVE MAINTENANCE TYPE ######################################################################### //
    getPvStepType() {
      this.$http.get(":9994/api/v1/setting/pvType").then((res) => {
        if (!res.error) {
          this.pvStepType = res.message;
        }
      });
    },
    getPvStepTypeRow(index, row) {
      this.pvStepIndex = index;
      this.selectedPvStep = row;
      this.newPvStepName = row.PvStepName;
    },
    addPvStepType() {
      if (this.newPvStepName == "") {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });

        return;
      }

      let body = {
        pvstepname: this.newPvStepName,
      };

      this.$http.post(":9994/api/v1/setting/pvType", body).then((res) => {
        if (!res.error) {
          swal({
            title: "Successful!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });

          this.getPvStepType();
          this.modals.addPvStepType = false;
        } else {
          swal({
            title: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.addPvStepType = false;
        }
      });
    },
    editPvStepType() {
      let body = {
        pvstepname: this.newPvStepName,
      };

      this.$http
        .put(
          `:9994/api/v1/setting/pvType/${this.selectedPvStep.PvStepTypeID}`,
          body
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.pvStepType[this.pvStepIndex]["pvstepname"] =
              this.newPvStepName;

            this.modals.editPvStepType = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editPvStepType = false;
          }
        });
    },

    // ######################################################################## (DZAF) INSPECTION STATUS ######################################################################### //
    getInspStat() {
      this.$http.get(":9991/api/v1/setting/inspectionStat").then((res) => {
        if (!res.error) {
          this.inspStat = res.message;
        }
      });
    },
    getInspStatRow(index, row) {
      this.inspNameIndex = index;
      this.selectedInspname = row;
      this.newInspName = row.statname;
    },
    addInspStat() {
      if (this.newInspName == "") {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });

        return;
      }

      let body = {
        statname: this.newInspName,
      };

      this.$http
        .post(":9991/api/v1/setting/inspectionStat", body)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.getInspStat();
            this.modals.addInspStat = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.addInspStat = false;
          }
        });
    },
    editInspStat() {
      // console.log(this.selectedPvStep);
      let body = {
        statid: this.selectedInspname.statid,
        statname: this.newInspName,
      };

      this.$http
        .put(":9991/api/v1/setting/inspectionStat", body)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.inspStat[this.inspNameIndex]["statname"] = this.newInspName;

            this.modals.editInspStat = false;
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editInspStat = false;
          }
        });
    },
    deleteInspStat(index, row) {
      this.$http
        .delete(`:9991/api/v1/setting/inspectionStat/${row.statid}`)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getInspStat();
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },

    // ######################################################################## (DZAF) FLEET OVERVIEW SETTINGS ######################################################################### //
    getFleetOverview() {
      this.$http.get(":9993/api/v1/setting/overview").then((res) => {
        if (!res.error) {
          let data = res.message;
          this.fleetAttributesData[0].check = data.TotalVehicle;
          this.fleetAttributesData[1].check = data.Replacement;
          this.fleetAttributesData[2].check = data.Requirement;
          this.fleetAttributesData[3].check = data.Available;
          this.fleetAttributesData[4].check = data.PercentAvailable;
          this.fleetAttributesData[5].check = data.Breakdown;
          this.fleetAttributesData[6].check = data.Unservice;
          this.loading = false;
        }
      });
    },
    updateFleetOverview() {
      let jwtToken = JSON.parse(
        atob(sessionStorage.getItem("token").split(".")[1])
      );
      let payload = {
        EmpID: jwtToken.employeeid,
        TotalVehicle: this.fleetAttributesData[0].check,
        Replacement: this.fleetAttributesData[1].check,
        Requirement: this.fleetAttributesData[2].check,
        Available: this.fleetAttributesData[3].check,
        PercentAvailable: this.fleetAttributesData[4].check,
        Breakdown: this.fleetAttributesData[5].check,
        Unservice: this.fleetAttributesData[6].check,
      };

      console.log(payload);
      this.$http.post(":9993/api/v1/setting/overview", payload).then((res) => {
        if (!res.error) {
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },

    // ################################################################################################################################################################## //
    getPickupFrequency() {
      // console.log(this.selects.monday);
      // console.log(this.selects.tuesday);
      // console.log(this.selects.wednesday);
      // console.log(this.selects.thursday);
      // console.log(this.selects.friday);
      // console.log(this.selects.saturday);
      // console.log(this.selects.sunday);
      // console.log(this._pickupPoint);
    },
    addSchedule() {
      // let x = {
      //   id: 1,
      //   routeName: "Klang Valley",
      //   pickupPoint: "ICWS",
      //   latitude: "Arm Roll",
      //   longitude: "Volvo",
      //   totalPickup: "DHES 1",
      //   totalBins: "12/12/2019",
      // },
    },
    test() {
      // console.log("Helllo");
    },
    //////////////////////////////////////////GENERAL FUNCTION////////////////////////////////////////
    getRow(row) {
      console.log(row);
      this.binType.binTypeId = `${row.BintypeID}`;
      this.binType.binName = `${row.binname}`;
      this.binType.binCapacity = `${row.bincapacity}`;
      this.binStatus.name = `${row.statusname}`;
      this.binStatus.id = `${row.statusid}`;
      this.region.name = `${row.region}`;
      this.region.id = `${row.regionId}`;
      this.route.name = `${row.route}`;
      this.route.id = `${row.routeID}`;
      this.route.region = `${row.regionID}`;
      // this.route.regionName = `${row.region`Name

      // department
      this.departmentName = `${row.department}`;
      this.departmentID = `${row.deptID}`;

      // fleet status
      this.fleetStatusName = `${row.fleetStatus}`;
      this.fleetStatusID = `${row.statusID}`;
      this.siteID = `${row.siteID}`;

      // site
      this.siteID = `${row.siteID}`;
      this.siteName = `${row.siteName}`;
      this.lat = `${row.lat}`;
      this.long = `${row.long}`;

      // owner
      this.ownerName = `${row.owner}`;
      this.ownerID = `${row.ownerID}`;

      // cost center
      this.costcenterName = `${row.costcenterName}`;
      this.costcenterID = `${row.costcenterID}`;

      // service area
      this.areaName = `${row.areaName}`;
      this.areaID = `${row.areaID}`;

      // service location
      this.locationID = `${row.locationID}`;
      this.locationName = `${row.locationName}`;
      this.locationLatitude = `${row.locationLatitude}`;
      this.locationLongitude = `${row.locationLongitude}`;

      // CEMS limit
      this.parameter = `${row.parameter}`;
      this.limit = `${row.limit}`;
      this.unit = `${row.unit}`;

      // CEMS Site
      this.cemssitename = `${row.cemssitename}`;
      this.cemssiteid = `${row.cemssiteid}`;
    },
    /////////////////////////////////////////////BIN TYPE//////////////////////////////////////////////
    getBinType() {
      this.$http.get(":9991/api/v1/setting/bin").then((res) => {
        // console.log(res.error);
        if (!res.error) {
          let response = res.message;
          // console.log(response.length);
          for (var i = 0; i < response.length; i++) {
            this.binTypeData.push(response[i]);
          }
          // console.log(this.binTypeData);
        } else {
          swal({
            title: "Data Error!",
            text: `${res.data.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });

      // empty the array
      this.binTypeData = [];
    },

    addBinType() {
      // console.log(this.binType.binName);
      // console.log(this.binType.binCapacity);

      let payload = {
        binname: this.binType.binName,
        bincapacity: this.binType.binCapacity,
      };

      // console.log(payload);

      this.$http.post(":9991/api/v1/setting/bin", payload).then((res) => {
        // console.log(res.error);
        if (!res.error) {
          let response = res.message;
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.addBinType = false;
          this.getBinType();
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    editBinType() {
      // console.log(this.binType.binName);
      // console.log(this.binType.binCapacity);
      // console.log(this.binType.binTypeId);

      let payload = {
        binname: this.binType.binName,
        bincapacity: this.binType.binCapacity,
      };

      // console.log(payload);

      this.$http
        .put(":9991/api/v1/setting/bin/" + this.binType.binTypeId, payload)
        .then((res) => {
          // console.log(res.error);
          // console.log(res.message);
          if (!res.error) {
            let response = res.message;
            // console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.edit = false;
            this.getBinType();
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    deleteBinType(index, row) {
      // console.log(index);
      // console.log(row);
      // console.log(row.BintypeID);

      this.$http
        .delete(":9991/api/v1/setting/bin/" + row.BintypeID)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getBinType();
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    /////////////////////////////////////////////////BIN STATUS////////////////////////////////////
    getBinStatus() {
      this.$http.get(":9991/api/v1/setting/status").then((res) => {
        if (!res.error) {
          // console.log(res.message);
          let response = res.message;
          for (var i = 0; i < response.length; i++) {
            this.binStatusData.push(response[i]);
          }
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
      this.binStatusData = [];
    },
    addBinStatus() {
      // console.log(this.binStatus.name);

      let payload = {
        statusname: this.binStatus.name,
      };

      this.$http.post(":9991/api/v1/setting/status", payload).then((res) => {
        if (!res.error) {
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.getBinStatus();
          this.modals.addBinStatus = false;
          this.binStatus.name = "";
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    editBinStatus() {
      // console.log(this.binStatus.name);
      // console.log(this.binStatus.id);

      let payload = {
        statusname: this.binStatus.name,
      };

      this.$http
        .put(":9991/api/v1/setting/status/" + this.binStatus.id, payload)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getBinStatus();
            this.modals.editBinStatus = false;
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
          this.binStatus.name = "";
        });
    },
    deleteStatus(index, row) {
      // console.log(index, row);
      // console.log(row.statusid);

      this.$http
        .delete(":9991/api/v1/setting/status/" + row.statusid)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getBinStatus();
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    //////////////////////////////////////////////////REGION///////////////////////////////////////////
    addRegion() {
      // console.log(this.region.name);

      let payload = {
        regionname: this.region.name,
      };

      this.$http.post(":9991/api/v1/customers/region", payload).then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.getRegion();
          this.modals.addRegion = false;
          this.region.name = "";
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    getRegion() {
      this.$http.get(":9991/api/v1/customers/region").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);

          for (var i = 0; i < response.length; i++) {
            let region = {
              region: response[i].RegionName,
              regionId: response[i].RegionID,
            };

            this.regionData.push(region);

            // for dropdown in add route function
            let option = {
              label: response[i].RegionName,
              value: response[i].RegionID,
            };

            this.regionOption.push(option);
          }
          // console.log(this.regionData);
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
      this.regionData = [];
    },
    editRegion() {
      // console.log(this.region.name);
      // console.log(this.region.id);

      let payload = {
        regionname: this.region.name,
      };

      this.$http
        .put(":9991/api/v1/customers/region/" + this.region.id, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            // console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getRegion();
            this.modals.editRegion = false;
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    deleteRegion(index, row) {
      // console.log(index);
      // console.log(row.regionId);

      this.$http
        .delete(":9991/api/v1/customers/region/" + row.regionId)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            // console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getRegion();
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    /////////////////////////////////////////////ROUTES/////////////////////////////////////
    getRoute() {
      this.$http.get(":9991/api/v1/customers/route").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);

          for (var i = 0; i < response.length; i++) {
            // console.log(response[i].RegionID);
            // console.log(this.regionData);
            let routeInfo = {
              route: response[i].RouteName,
              routeID: response[i].RouteID,
              regionID: response[i].RegionID,
            };
            this.routeData.push(routeInfo);
          }
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
        this.loading = false;
      });
      this.routeData = [];
    },
    addRoute() {
      // console.log(this.route.name);
      // console.log(this.route.region);

      let payload = {
        RouteName: this.route.name,
        RegionID: this.route.region,
      };

      console.log(payload);
      this.$http.post(":9991/api/v1/customers/route", payload).then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(respon9se);
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.getRoute();
          this.route.name = "";
          this.route.region = "";
          this.modals.addRoute = false;
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    editRoute() {
      // console.log(this.route.name);
      // console.log(this.route.region);
      // console.log(this.route.id);

      let payload = {
        routename: this.route.name,
        region: this.route.region,
      };

      this.$http
        .put(":9991/api/v1/customers/route/" + this.route.id, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            // console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getRoute();
            this.route.name = "";
            this.route.region = "";
            this.modals.editRoute = false;
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    deleteRoute(index, row) {
      // console.log(index);
      // console.log(row);
      // console.log(row.routeID);

      this.$http
        .delete(":9991/api/v1/customers/route/" + row.routeID)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            // console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.getRoute();
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    getDepartment() {
      this.departmentData = [];
      this.$http.get(":9992/api/v1/admin/dept").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              department: response[i].DeptName,
              deptID: response[i].DeptID,
            };
            this.departmentData.push(obj);
          }
          this.loading = false;
        }
      });
    },
    addDepartment() {
      if (this.departmentName == "") {
        swal({
          title: "Data Error!",
          text: "Form cannot be empty",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      } else {
        let payload = {
          deptname: this.departmentName,
        };
        this.$http.post(":9992/api/v1/admin/dept", payload).then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.departmentName = "";
            this.getDepartment();
            this.modals.adddepartment = false;
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
      }
    },
    editDepartment() {
      console.log(this.departmentName);
      console.log(this.departmentID);
      let payload = {
        DeptID: parseInt(this.departmentID),
        DeptName: this.departmentName,
      };

      console.log(payload);
      this.$http
        .put(":9992/api/v1/admin/dept/" + this.departmentID, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.departmentName = "";
            this.departmentID = "";
            this.getDepartment();
            this.modals.editdepartment = false;
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    getFleetStatus() {
      this.fleetStatusData = [];
      this.$http.get(":9993/api/v1/setting/status").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              fleetStatus: response[i].StatusName,
              statusID: response[i].StatusID,
            };
            this.fleetStatusData.push(obj);
          }
        }
      });
    },
    addFleetStatus() {
      console.log(this.fleetStatusName);
      if (this.fleetStatusName == "") {
        swal({
          title: "Data Error!",
          text: "Form cannot be empty",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      } else {
        let payload = {
          StatusName: this.fleetStatusName,
        };
        this.$http.post(":9993/api/v1/setting/status", payload).then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.fleetStatusName = "";
            this.getFleetStatus();
            this.modals.addfleetstatus = false;
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
      }
    },
    editFleetStatus() {
      console.log(this.fleetStatusName);
      console.log(this.fleetStatusID);
      let payload = {
        StatusID: parseInt(this.fleetStatusID),
        StatusName: this.fleetStatusName,
      };

      console.log(payload);
      this.$http
        .put(":9993/api/v1/setting/status/" + this.fleetStatusID, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.fleetStatusName = "";
            this.fleetStatusID = "";
            this.getFleetStatus();
            this.modals.editfleetstatus = false;
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    // service area
    getServiceArea() {
      this.$http.get(":9995/api/v1/manage/area").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              areaID: response[i].ServiceAreaID,
              areaName: response[i].ServiceAreaName,
            };
            this.servicearea.push(obj);
          }
        }
      });
    },
    addServiceArea() {
      this.servicearea = [];
      console.log(this.areaName);
      let payload = {
        ServiceAreaName: this.areaName,
      };
      this.$http.post(":9995/api/v1/manage/area", payload).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.addServiceArea = false;
          this.areaName = "";
          this.areaID = "";
          this.getServiceArea();
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    editServiceArea() {
      this.servicearea = [];
      console.log(this.areaName, this.areaID);
      let payload = {
        ServiceAreaID: parseInt(this.areaID),
        ServiceAreaName: this.areaName,
      };

      this.$http.put(":9995/api/v1/manage/area", payload).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.editServiceArea = false;
          this.areaName = "";
          this.areaID = "";
          this.getServiceArea();
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    // service location
    getServiceLocation() {
      this.servicelocation = [];
      this.$http.get(":9995/api/v1/manage/location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              locationID: response[i].WorkLocationID,
              locationName: response[i].LocationName,
              locationLatitude: response[i].Latitude,
              locationLongitude: response[i].Longitude,
            };
            this.servicelocation.push(obj);
          }
          this.loading = false;
        }
      });
    },
    addServiceLocation() {
      this.servicelocation = [];
      console.log(
        this.locationName,
        this.locationLatitude,
        this.locationLongitude
      );
      let payload = {
        LocationName: this.locationName,
        Latitude: parseFloat(this.locationLatitude),
        Longitude: parseFloat(this.locationLongitude),
      };
      this.$http.post(":9995/api/v1/manage/location", payload).then((res) => {
        if (!res.error) {
          let response = res.message;
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.addServiceLocation = false;
          this.locationName = "";
          this.locationID = "";
          this.locationLatitude = "";
          this.locationLongitude = "";
          this.getServiceLocation();
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    editServiceLocation() {
      let payload = {};
      console.log(this.servicelocation);

      for (var i = 0; i < this.servicelocation.length; i++) {
        console.log(this.locationName != this.servicelocation[i].locationName);
        // check name existance
        if (this.servicelocation[i].locationName != this.locationName) {
          payload = {
            LocationName: this.locationName,
            Latitude: parseFloat(this.locationLatitude),
            Longitude: parseFloat(this.locationLongitude),
          };
        } else {
          payload = {
            Latitude: parseFloat(this.locationLatitude),
            Longitude: parseFloat(this.locationLongitude),
          };
          break;
        }
      }

      console.log(payload);
      this.$http
        .put(":9995/api/v1/manage/location/" + this.locationID, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editServiceLocation = false;
            this.locationName = "";
            this.locationID = "";
            this.locationLatitude = "";
            this.locationLongitude = "";
            this.getServiceLocation();
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    // CEMS Site
    getCEMSSite() {
      this.cemssites = [];

      this.$http.get(":9997/api/v1/setting/plant").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              cemssiteid: response[i].PlantID,
              cemssitename: response[i].PlantName,
            };
            this.cemssites.push(obj);
          }
          this.loading = false;
        }
      });
    },
    addCEMSSite() {
      this.cemssites = [];
      console.log(this.cemssitename);
      let payload = {
        PlantName: this.cemssitename,
      };
      this.$http.post(":9997/api/v1/setting/plant", payload).then((res) => {
        if (!res.error) {
          // let response = res.message;
          swal({
            title: "Successfull!",
            text: `${res.message}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals.addCEMSSite = false;
          this.cemssitename = "";

          this.getCEMSSite();
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    editCEMSSite() {
      console.log(this.cemssiteid, this.cemssitename);
      this.cemssites = [];

      let payload = {
        PlantName: this.cemssitename,
      };

      this.$http
        .put(":9997/api/v1/setting/plant/" + this.cemssiteid, payload)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.modals.editCEMSSite = false;
            this.cemssitename = "";
            this.cemssiteid = "";

            this.getCEMSSite();
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    getSupplier() {
      this.suppliers = [];

      this.$http.get(":10001/api/v1/setting/supplier").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              suppliercode: response[i].SupplierCode,
              suppliername: response[i].SupplierName,
              isprivatecontractor: response[i].IsPrivateContractor,
            };
            this.suppliers.push(obj);
          }
        }
      });
    },
    addSupplier() {
      if (this.suppliercode != "" && this.suppliername != "") {
        let obj = {
          SupplierCode: this.suppliercode,
          SupplierName: this.suppliername,
          IsPrivateContractor: this.privatecontractor,
        };

        this.$http.post(":10001/api/v1/setting/supplier", obj).then((res) => {
          if (!res.error) {
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.suppliercode = "";
            this.suppliername = "";
            this.privatecontractor = false;
            this.modals.addSupplier = false;
            this.getSupplier();
          }
        });
      } else {
        swal({
          title: "Info!",
          text: "Supplier code and supplier name are required!",
          type: "info",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      }
    },
    getDestination() {
      this.destinations = [];

      this.$http.get(":10001/api/v1/setting/destination").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              destinationcode: response[i].DestinationCode,
              destinationname: response[i].DestinationName,
            };
            this.destinations.push(obj);
          }
        }
      });
    },
    addDestination() {
      if (this.destinationcode != "" && this.destinationname != "") {
        let obj = {
          DestinationCode: this.destinationcode,
          DestinationName: this.destinationname,
        };

        this.$http
          .post(":10001/api/v1/setting/destination", obj)
          .then((res) => {
            if (!res.error) {
              swal({
                title: "Successfull!",
                text: `${res.message}`,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });

              this.destinationcode = "";
              this.destinationname = "";
              this.modals.addDestination = false;
              this.getDestination();
            }
          });
      } else {
        swal({
          title: "Info!",
          text: "Destination code and destination name are required!",
          type: "info",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      }
    },
    getProductTypes() {
      this.producttypes = [];

      this.$http.get(":10001/api/v1/setting/product-type").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              producttypecode: response[i].ProductTypeCode,
              producttypename: response[i].ProductTypeName,
            };

            this.producttypes.push(obj);
          }
        }
      });
    },
    addProductTypes() {
      if (this.producttypecode != "" && this.producttypename != "") {
        let obj = {
          ProductTypeCode: this.producttypecode,
          ProductTypeName: this.producttypename,
        };

        this.$http
          .post(":10001/api/v1/setting/product-type", obj)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              swal({
                title: "Successfull!",
                text: `${res.message}`,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });

              this.producttypecode = "";
              this.producttypename = "";
              this.modals.addproducttype = false;
              this.getProductTypes();
            }
          });
      } else {
        swal({
          title: "Info!",
          text: "Product type code and product type name are required!",
          type: "info",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      }
    },
    getTransport() {
      this.transports = [];

      this.$http.get(":10001/api/v1/setting/transport-code").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              transportcode: response[i].TransportCode,
              transportcodename: response[i].TransportCodeName,
            };
            this.transports.push(obj);
          }
          this.loading = false;
        }
      });
    },
    addTransport() {
      if (this.transportcode != "" && this.transportcodename != "") {
        let obj = {
          TransportCode: this.transportcode,
          TransportCodeName: this.transportcodename,
        };

        this.$http
          .post(":10001/api/v1/setting/transport-code", obj)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              swal({
                title: "Successfull!",
                text: `${res.message}`,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });

              this.transportcode = "";
              this.transportcodename = "";
              this.modals.addtransport = false;
              this.getTransport();
            }
          });
      } else {
        swal({
          title: "Info!",
          text: "Transport code and transport code name are required!",
          type: "info",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      }
    },
    initIsChecked() {
      const stored = sessionStorage.getItem("tab-current");
      console.log(stored);
    },
  },

  created() {
    this.currenttabs = "General";
    // console.log(this.TabData)

    this.getBinStatus();

    this.getPvStepType();
  },
  watch: {
    currenttabs() {
      this.loading = true;
      console.log(this.currenttabs);
      if (this.currenttabs == "General") {
        this.getDepartment();
      }

      if (this.currenttabs == "Fleet") {
        this.getFleetStatus();
        this.getFleetOverview();
      }

      if (this.currenttabs == "Green Card") {
        this.getBinType();
        this.getInspStat();
        this.getRegion();
        this.getRoute();
      }

      if (this.currenttabs == "Incident") {
        this.getIncident();
        this.getAccidentType();
        this.getAccidentCause();
        this.getAccidentClass();
      }

      if (this.currenttabs == "Asset") {
        this.getSite();
        this.getOwner();
        this.getCostCenter();
      }

      if (this.currenttabs == "Attendance") {
        this.getServiceArea();
        this.getServiceLocation();
      }

      if (this.currenttabs == "CEMS") {
        //  this.getCemsLimit()
        this.getCEMSSite();
      }

      if (this.currenttabs == "Weightbridge") {
        this.getSupplier();
        this.getDestination();
        this.getProductTypes();
        this.getTransport();
      }
    },
  },
};
</script>
<style lang="scss">
// .card {
//   background-color: #222a42;
//   padding-top: 4%;
//   padding-left: 4%;
//   padding-right: 4%;
//   padding-bottom: 1%;
//   box-shadow: 0 4px 8px 0 rgba(26, 26, 26, 0.2),
//     0 6px 20px 0 rgba(26, 26, 26, 0.19);
// }

.setting {
  background: #222a42;
}
.select-day {
  padding-left: 0%;
}
.group-form {
  border: solid red;
  border-radius: 20px;
  padding: 2%;
  margin-bottom: 2%;
  margin-right: 2%;
}
table > tbody {
  color: black;
}
.text-color {
  color: black;
}
/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 13px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #bec4c4;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
